export default __webpack_public_path__ + "static/media/medicare-card-new.f3d2d9b3.png";